import MobileVideoCard from './MobileVideoCard';

export default MobileVideoCard;
